import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getProductById } from "../api/apiCalls";
import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import {
  Container,
  Card,
  CardMedia,
  Typography,
  Button,
  Box,
  Stack,
} from "@mui/material";
import { ShoppingCart } from "@mui/icons-material";

const ProductDetail = () => {
  const { userState, dispatch } = useContext(UserContext); // Access global user state and dispatch function

  const { id } = useParams(); // Get the product ID from the URL parameters
  const [product, setProduct] = useState(null); // State to store product details

  useEffect(() => {
    const getProduct = async () => {
      const data = await getProductById(id); // Fetch product details based on ID
      setProduct(data); // Update product state
    };
    getProduct();
  }, [id]); // Re-run effect when ID changes

  if (!product) return "Loading.."; // Show loading text while fetching data

  return (
    <Container sx={{ mt: "80px", mb: "30px" }}>
      <Typography
        variant="h5"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: "30px",
        }}
        color="primary"
      >
        Product Details
      </Typography>
      <Stack
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" }, // Adjust layout based on screen size
          justifyContent: "center",
          alignItems: "center",
          gap: "30px",
        }}
      >
        <Box>
          <Card
            sx={{
              borderRadius: 3,
              overflow: "hidden",
              boxShadow: 3,
              height: { xs: "50vh", md: "80vh" },
              width: { xs: "50vh", md: "80vh" },
              "&:hover img": { transform: "scale(1.05)" }, // Image zoom effect on hover
            }}
          >
            <CardMedia
              component="img"
              image={product.images[0]} // Display first product image
              alt={product.title}
              sx={{
                width: "100%",
                transition: "transform 0.3s ease-in-out",
              }}
            />
          </Card>
        </Box>

        <Box sx={{ color: "white" }}>
          <Typography variant="h4" fontWeight="bold">
            {product.title} {/* Display product title */}
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
            {product.description} {/* Display product description */}
          </Typography>

          <Typography
            variant="h6"
            color="primary"
            sx={{ mt: 2, fontWeight: "bold" }}
          >
            ${product.price} {/* Display product price */}
          </Typography>

          <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
            {userState.username && ( // Show "Add to Cart" button only if the user is logged in
              <Button
                variant="contained"
                color="primary"
                startIcon={<ShoppingCart />}
                sx={{
                  color: "white",
                  borderRadius: "10px",
                  padding: "8px 15px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                }}
                onClick={() => {
                  dispatch({ type: "addToCart", payload: product }); // Add product to cart
                }}
              >
                Add to Cart
              </Button>
            )}
          </Box>
        </Box>
      </Stack>
    </Container>
  );
};

export default ProductDetail; // Export ProductDetail component
